import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Market } from '@entity/market';
import { MarketService } from '@service/market.service';

export const MarketResolve: ResolveFn<Market> = (route) => {
  return inject(MarketService).getMarket(route.params.id);
};
